import { css } from "@compiled/react";

import { SwooshLeftLight } from "../../graphics/swoosh-left-light";
import { SwooshRightLight } from "../../graphics/swoosh-right-light";
import { TestimonialCardsSection } from "../testimonials";

const sectionStyles = css({
    position: "relative"
});

const contentWrapperStyles = css({
    "position": "relative",
    "padding": "32px 16px",
    "margin": "auto",

    "@media (min-width: 64rem)": {
        width: "83.33333%"
    }
});

const swooshLeft = css({
    "position": "absolute",
    "insetBlockStart": 16,
    "insetInlineStart": 0,

    "@media(max-width: 63.99rem)": {
        display: "none"
    }
});

const swooshRight = css({
    "position": "absolute",
    "insetBlockStart": 60,
    "insetInlineEnd": 0,

    "@media (max-width: 63.99rem)": {
        display: "none"
    }
});

const TestimonialsSection = () => {
    return (
        <section css={sectionStyles}>
            <div css={swooshLeft}>
                <SwooshLeftLight />
            </div>
            <div css={swooshRight}>
                <SwooshRightLight />
            </div>
            <div css={contentWrapperStyles}>
                <TestimonialCardsSection />
            </div>
        </section>
    );
};

export default TestimonialsSection;
